import fetchGraphQL from './api';

export type Client = {
    id: string;
    name: string;
    slug: string;
    active: boolean;
    description: string;
    brief?: string;
    logo: {
        url: string;
        description: string;
    };
    /** Show the logo as uploaded, for artwork that can't survive the flat-white silhouette (it has a solid plate). */
    logoAsSupplied?: boolean;
    backgroundColor?: string;
    url?: string;
    orderNumber: number;
    disabled: boolean;
};

const query = `query {
    clientCollection(order: id_ASC) {
        items {
            id
            name
            slug
            active
            description
            brief
            logo {
                url
                description 
            }
            logoAsSupplied
            backgroundColor 
            url  
            orderNumber      
            disabled           
        }
    }
  }`;

export const getClient = async (): Promise<Client[]> => {
    const response = await fetchGraphQL<{ clientCollection: { items: Client[] } | null }>(query);

    if (!response || !response.data) {
        throw new Error('Failed to get content response - Client');
    }

    const { clientCollection } = response.data;
    if (!clientCollection) {
        throw new Error('Failed to get content - no Client');
    }

    return clientCollection.items.map((c: Client) => ({
        id: c.id,
        name: c.name,
        slug: c.slug,
        active: c.active,
        description: c.description,
        logo: {
            url: c.logo?.url || '',
            description: c.logo?.description || '',
        },
        logoAsSupplied: c.logoAsSupplied === true,
        backgroundColor: c.backgroundColor || '#f9cf0c',
        brief: c.brief || '',
        url: c.url || '',
        orderNumber: c.orderNumber || 0,
        disabled: c.disabled || false,
    }));
};
